export const ACCESS_STATE_UNKNOWN = 'unknown';
export const ACCESS_STATE_LOBBY = 'lobby';
export const ACCESS_STATE_FULL = 'full';
export const ACCESS_STATE_NONE = 'none';

export const MEETING_STATE_JOINED = 'joined-meeting';

export const VIDEO_QUALITY_AUTO = 'auto';
export const VIDEO_QUALITY_HIGH = 'high';
export const VIDEO_QUALITY_LOW = 'low';
export const VIDEO_QUALITY_VERY_LOW = 'very-low';
export const VIDEO_QUALITY_BANDWIDTH_SAVER = 'bandwidth-saver';

export const DEFAULT_ASPECT_RATIO = 16 / 9;
